import React from 'react';
import { MdFullscreen, MdRefresh, MdSync } from 'react-icons/md';

import {
    Box,
    Button,
    Chip,
    FormControlLabel,
    IconButton,
    Switch,
    Tooltip,
    Typography,
} from '@material-ui/core';

import LocaleMessage from '~/components/LocaleMessage';

export default function CleaningReportPluginspaceLiveShell({
    classes,
    lastUpdatedLabel,
    reportLoading,
    onRefresh,
    onForceFullSync,
    autoRefresh,
    onAutoRefreshChange,
    onEnterFullscreen,
}) {
    return (
        <Box className={classes.liveShell}>
            <div className={classes.liveTitleRow}>
                <div>
                    <Typography variant="h5" component="h2">
                        <LocaleMessage msg="page.robots.cleaning_report.live.heading" />
                    </Typography>
                    <Typography className={classes.metaMuted}>
                        <LocaleMessage msg="page.robots.cleaning_report.live.subtitle" />
                    </Typography>
                </div>
                <Box display="flex" alignItems="center" flexWrap="wrap">
                    <Chip
                        size="small"
                        color="primary"
                        label={
                            <LocaleMessage msg="page.robots.cleaning_report.live.badge_live" />
                        }
                        className={classes.liveBadge}
                        style={{ marginRight: 8 }}
                    />
                    <Typography
                        component="span"
                        variant="body2"
                        color="textSecondary"
                    >
                        <LocaleMessage msg="page.robots.cleaning_report.live.last_updated" />
                        {': '}
                        {lastUpdatedLabel}
                        {reportLoading ? ' …' : ''}
                    </Typography>
                </Box>
            </div>
            <div className={classes.toolbarRow}>
                <Tooltip
                    title={
                        <LocaleMessage msg="page.robots.cleaning_report.live.refresh_now" />
                    }
                >
                    <span>
                        <IconButton
                            color="primary"
                            onClick={onRefresh}
                            disabled={reportLoading}
                            aria-label="refresh"
                        >
                            <MdRefresh
                                size={22}
                                className={
                                    reportLoading
                                        ? classes.refreshSpinning
                                        : undefined
                                }
                            />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip
                    title={
                        <LocaleMessage msg="page.robots.cleaning_report.live.force_full_sync_tooltip" />
                    }
                >
                    <span className="ml-1">
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            startIcon={<MdSync size={18} />}
                            onClick={onForceFullSync}
                            disabled={reportLoading}
                        >
                            <LocaleMessage msg="page.robots.cleaning_report.live.force_full_sync" />
                        </Button>
                    </span>
                </Tooltip>
                <FormControlLabel
                    control={
                        <Switch
                            checked={autoRefresh}
                            onChange={onAutoRefreshChange}
                            color="primary"
                        />
                    }
                    label={
                        <LocaleMessage msg="page.robots.cleaning_report.live.auto_refresh" />
                    }
                />
                <Tooltip
                    title={
                        <LocaleMessage msg="page.robots.cleaning_report.live.fullscreen_data" />
                    }
                >
                    <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        startIcon={<MdFullscreen size={20} />}
                        onClick={onEnterFullscreen}
                    >
                        <LocaleMessage msg="page.robots.cleaning_report.live.fullscreen_data" />
                    </Button>
                </Tooltip>
            </div>
        </Box>
    );
}
